
<h4>Horizontal Rule</h4><br><br>
<div class="select-access-level">Access Level:</div>
<div class="input-type-select-access-level" [(accessLevel)]="section.accessLevel"></div><br><br>
<div class="select-background-color">Color</div>
<div class="select-background-color-block" *ngFor="let color of app.colors;" [style.background-color]="color" (click)="section.contentBackgroundColor = color"></div><a class="reset-background active" (click)="section.contentBackgroundColor = null">Reset</a><br><br>